import { useTranslation } from "react-i18next";

/**
 * Šta je kvalitet rekao o LOT-u: usaglašen (sme svakom kupcu), SS (samo za prodaju u Srbiji, ne za izvoz) ili
 * neusaglašen (ne ide kupcu). LOT bez statusa je neobrađen: kvalitet ga još nije ocenio.
 */
export type LotQualityStatus = "CONFORMING" | "DOMESTIC_ONLY" | "NONCONFORMING";

export const LOT_QUALITY_STATUSES: LotQualityStatus[] = ["CONFORMING", "DOMESTIC_ONLY", "NONCONFORMING"];

export function LotQualityBadge({ status, note }: { status: string | null | undefined; note?: string | null }) {
  const { t } = useTranslation();
  const [boja, tekst, opis] =
    status === "CONFORMING"
      ? ["ok", t("lotQuality.status.CONFORMING", "usaglašen"), t("lotQuality.hint.CONFORMING", "Sme svakom kupcu, domaćem i stranom.")]
      : status === "DOMESTIC_ONLY"
        ? ["warn", t("lotQuality.status.DOMESTIC_ONLY", "SS"), t("lotQuality.hint.DOMESTIC_ONLY", "Samo za prodaju u Srbiji, ne za izvoz.")]
        : status === "NONCONFORMING"
          ? ["err", t("lotQuality.status.NONCONFORMING", "neusaglašen"), t("lotQuality.hint.NONCONFORMING", "Ne ide kupcu.")]
          : ["", t("lotQuality.status.OPEN", "neobrađen"), t("lotQuality.hint.OPEN", "Kvalitet LOT još nije ocenio.")];
  return (
    <span className={boja ? `tag ${boja}` : "tag"} title={note ? `${opis} ${note}` : opis}>
      {tekst}
    </span>
  );
}
